import { MODULE_PATHS } from '../../utils/const';
import { CustomObject } from '../../types';

const lowerCased = (obj: CustomObject) =>
	Object.entries(obj).reduce((result, [key, value]) => {
		result[key.toLowerCase()] = value;

		return result;
	}, {});

/**
 * Object mapping page paths to their corresponding page type IDs in the tool navigation.
 */
export const PATH_TO_PAGE_TYPE_ID_MAP = lowerCased({
	[MODULE_PATHS.activityList]: 866,
	[MODULE_PATHS.activityTaskList]: 849,
	[MODULE_PATHS.agencyCommonDetails]: 80,
	[MODULE_PATHS.structure]: 170,
	[MODULE_PATHS.agencyList]: 80,
	[MODULE_PATHS.allJobs]: 477,
	[MODULE_PATHS.apiUserCommonDetails]: 31,
	[MODULE_PATHS.apiUserList]: 31,
	[MODULE_PATHS.applicationForm]: 311,
	[MODULE_PATHS.applicationsCommonDetails]: 308,
	[MODULE_PATHS.applicationsList]: 308,
	[MODULE_PATHS.auditTrailList]: 244,
	[MODULE_PATHS.automationDetails]: 917,
	[MODULE_PATHS.automationList]: 917,
	[MODULE_PATHS.automationLogList]: 922,
	[MODULE_PATHS.calculationSchemeDetails]: 886,
	[MODULE_PATHS.calculationSchemeList]: 886,
	[MODULE_PATHS.candidateChangeList]: 188,
	[MODULE_PATHS.candidateCommonDetailsNew]: 84,
	[MODULE_PATHS.candidateList]: 84,
	[MODULE_PATHS.candidatePensionList]: 902,
	[MODULE_PATHS.candidateStatusMappingList]: 927,
	[MODULE_PATHS.caoDetails]: 75,
	[MODULE_PATHS.caoInstanceDetails]: 79,
	[MODULE_PATHS.caoList]: 75,
	[MODULE_PATHS.caoListInstance]: 79,
	[MODULE_PATHS.caoNewsDetail]: 39,
	[MODULE_PATHS.caoNewsList]: 39,
	[MODULE_PATHS.caoWagesList]: 119,
	[MODULE_PATHS.caoWagesRequestDetails]: 135,
	[MODULE_PATHS.caoWagesRequestList]: 135,
	[MODULE_PATHS.clockwiseDetail]: 37,
	[MODULE_PATHS.clockwiseList]: 37,
	[MODULE_PATHS.commentsList]: 401,
	[MODULE_PATHS.communitiesCommonDetails]: 284,
	[MODULE_PATHS.communitiesList]: 284,
	[MODULE_PATHS.componentModelDetail]: 486,
	[MODULE_PATHS.componentModelList]: 486,
	[MODULE_PATHS.connectDashboardList]: 277,
	[MODULE_PATHS.connectSettings]: 215,
	[MODULE_PATHS.connectorDetail]: 930,
	[MODULE_PATHS.connectorList]: 930,
	[MODULE_PATHS.contactPersonDetail]: 185,
	[MODULE_PATHS.contactPersonList]: 185,
	[MODULE_PATHS.contractCommonDetails]: 76,
	[MODULE_PATHS.contractsList]: 76,
	[MODULE_PATHS.contractsUpdateDetail]: 926,
	[MODULE_PATHS.contractsUpdateList]: 926,
	[MODULE_PATHS.customCaoDetails]: 920,
	[MODULE_PATHS.customCaoInstanceDetails]: 924,
	[MODULE_PATHS.customCaoInstanceList]: 924,
	[MODULE_PATHS.customCaoList]: 920,
	[MODULE_PATHS.customerDetails]: 225,
	[MODULE_PATHS.customerInvoiceComponentList]: 273,
	[MODULE_PATHS.customerInvoiceDetails]: 862,
	[MODULE_PATHS.customerInvoiceList]: 862,
	[MODULE_PATHS.customerList]: 225,
	[MODULE_PATHS.customerSubscriptionsDetails]: 855,
	[MODULE_PATHS.customerSubscriptionsList]: 855,
	[MODULE_PATHS.dashboard]: 71,
	[MODULE_PATHS.managementInformation]: 72,
	[MODULE_PATHS.dealsCommonDetails]: 904,
	[MODULE_PATHS.dealsList]: 904,
	[MODULE_PATHS.documentList]: 78,
	[MODULE_PATHS.documentSettingsDetail]: 268,
	[MODULE_PATHS.documentSettingsList]: 268,
	[MODULE_PATHS.documentTemplateDetails]: 368,
	[MODULE_PATHS.documentTemplateList]: 368,
	'/domainvalue/caoMapping': 353, //todo: replace with MODULE_PATHS property when detail is moved to react
	[MODULE_PATHS.domainValueDetail]: 310,
	[MODULE_PATHS.domainValueList]: 310,
	[MODULE_PATHS.domainValueMappingList]: 396,
	[MODULE_PATHS.emailSenderAuthCommonDetails]: 370,
	[MODULE_PATHS.emailSenderAuthList]: 370,
	[MODULE_PATHS.employerCommonDetails]: 43,
	[MODULE_PATHS.employerList]: 43,
	[MODULE_PATHS.flexNetCustomerDetail]: 301,
	[MODULE_PATHS.flexNetCustomerList]: 301,
	[MODULE_PATHS.flexNetHostDetail]: 297,
	[MODULE_PATHS.flexNetHostList]: 297,
	[MODULE_PATHS.flexNetHostSettingsDetail]: 422,
	[MODULE_PATHS.formCommonDetails]: 898,
	[MODULE_PATHS.formDesignerDetail]: 896,
	[MODULE_PATHS.formDesignerList]: 896,
	[MODULE_PATHS.formList]: 898,
	[MODULE_PATHS.formPublic]: 304,
	[MODULE_PATHS.formPublicViaLink]: 896,
	[MODULE_PATHS.fsApiLogList]: 323,
	[MODULE_PATHS.illnessCommonDetails]: 52,
	[MODULE_PATHS.illnessList]: 52,
	[MODULE_PATHS.incomingMessage]: 213,
	[MODULE_PATHS.incomingMessageList]: 213,
	[MODULE_PATHS.incomingMessageLogList]: 202,
	[MODULE_PATHS.invoiceList]: 832,
	[MODULE_PATHS.jobBoardDetails]: 465,
	[MODULE_PATHS.jobBoardInstanceDetail]: 459,
	[MODULE_PATHS.jobBoardInstanceList]: 459,
	[MODULE_PATHS.jobBoardList]: 465,
	[MODULE_PATHS.jobCommonDetails]: 193,
	[MODULE_PATHS.jobList]: 193,
	[MODULE_PATHS.jobPostDetail]: 506,
	[MODULE_PATHS.jobPostList]: 506,
	[MODULE_PATHS.labelDetails]: 413,
	[MODULE_PATHS.labelList]: 413,
	[MODULE_PATHS.modelMatrixDetail]: 445,
	[MODULE_PATHS.modelMatrixInstanceDetail]: 102,
	[MODULE_PATHS.modelMatrixInstanceList]: 102,
	[MODULE_PATHS.modelMatrixList]: 445,
	[MODULE_PATHS.newsAdminCommonDetails]: 64,
	[MODULE_PATHS.newsCommonDetails]: 62,
	[MODULE_PATHS.newsList]: 62,
	[MODULE_PATHS.newsadminList]: 64,
	[MODULE_PATHS.optOutList]: 425,
	[MODULE_PATHS.outgoingMessageDetails]: 214,
	[MODULE_PATHS.outgoingMessageList]: 214,
	[MODULE_PATHS.outgoingMessageLogList]: 206,
	[MODULE_PATHS.pageDetails]: 890,
	[MODULE_PATHS.pageList]: 890,
	[MODULE_PATHS.paymentList]: 270,
	[MODULE_PATHS.payslipList]: 200,
	[MODULE_PATHS.payslipsCommonDetails]: 200,
	[MODULE_PATHS.periodicComponentsList]: 907,
	[MODULE_PATHS.phaseList]: 151,
	[MODULE_PATHS.proformaDetails]: 913,
	[MODULE_PATHS.proformaList]: 913,
	[MODULE_PATHS.publicDocumentAuthentication]: 28,
	[MODULE_PATHS.publicDocumentList]: 29,
	[MODULE_PATHS.publicEmployerDetail]: 882,
	[MODULE_PATHS.publicEmployerList]: 882,
	[MODULE_PATHS.publicJobApply]: 189,
	[MODULE_PATHS.publicJobDetail]: 195,
	[MODULE_PATHS.publicJobList]: 195,
	[MODULE_PATHS.publicNewsDetail]: 281,
	[MODULE_PATHS.publicNewsList]: 281,
	[MODULE_PATHS.purchaseInvoiceList]: 932,
	[MODULE_PATHS.rateClassDetail]: 298,
	[MODULE_PATHS.rateClassList]: 298,
	[MODULE_PATHS.reservationList]: 134,
	[MODULE_PATHS.rolesCommonDetails]: 208,
	[MODULE_PATHS.rolesList]: 208,
	[MODULE_PATHS.safetyList]: 923,
	[MODULE_PATHS.savedFilterAdminList]: 452,
	[MODULE_PATHS.savedFilterLogsList]: 453,
	[MODULE_PATHS.savedFilterMyList]: 451,
	[MODULE_PATHS.savedFilterOwnList]: 450,
	[MODULE_PATHS.settingList]: 104,
	[MODULE_PATHS.shareLogDetail]: 878,
	[MODULE_PATHS.shareLogList]: 878,
	[MODULE_PATHS.subscriberList]: 59,
	[MODULE_PATHS.subscriptionSettingDetails]: 176,
	[MODULE_PATHS.subscriptionSettingList]: 176,
	[MODULE_PATHS.suppliersList]: 915,
	[MODULE_PATHS.supportAccessList]: 911,
	[MODULE_PATHS.surveyAdminDetails]: 871,
	[MODULE_PATHS.surveyAdminList]: 871,
	[MODULE_PATHS.surveyCommonDetails]: 402,
	[MODULE_PATHS.surveyList]: 402,
	[MODULE_PATHS.tagList]: 357,
	[MODULE_PATHS.templateDetails]: 57,
	[MODULE_PATHS.templateList]: 57,
	[MODULE_PATHS.testCalculationScheme]: 908,
	[MODULE_PATHS.textModelDetails]: 495,
	[MODULE_PATHS.textModelList]: 495,
	[MODULE_PATHS.translationDetails]: 354,
	[MODULE_PATHS.translationList]: 354,
	[MODULE_PATHS.userCommonDetails]: 99,
	[MODULE_PATHS.userProfile]: 113,
	[MODULE_PATHS.wmlDetails]: 35,
	[MODULE_PATHS.wmlList]: 35,
	[MODULE_PATHS.userList]: 99,
	[MODULE_PATHS.backofficeActionPage]: 933,
	[MODULE_PATHS.journalTransferFilesList]: 934,
	[MODULE_PATHS.backofficeProcessingList]: 935,
	[MODULE_PATHS.backofficePaymentTransferFilesList]: 936,
});
